import { useEffect, useState } from "react";
import {
  Button,
  Group,
  NumberInput,
  Paper,
  Select,
  Text,
  Title,
} from "@mantine/core";
import { notifications } from "@mantine/notifications";
import { updateTenantSkuOffer } from "../api";
import { useTenantStore } from "../../../Boilerplate/AdminTenants/tenantStore";

export default function SkuOfferEditor({ tenantId }) {
  const tenant = useTenantStore((state) => state.tenants[tenantId]);
  const fetchTenant = useTenantStore((state) => state.fetchTenant);
  const [currency, setCurrency] = useState(tenant?.skuOfferCurrency || "");
  const [minor, setMinor] = useState(tenant?.skuOfferMinorPerSku || 50);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setCurrency(tenant?.skuOfferCurrency || "");
    setMinor(tenant?.skuOfferMinorPerSku || 50);
  }, [tenant?.skuOfferCurrency, tenant?.skuOfferMinorPerSku]);

  if (!tenant) return null;

  const save = async (payload) => {
    setSaving(true);
    try {
      await updateTenantSkuOffer(tenantId, payload);
      await fetchTenant(tenantId, true);
      notifications.show({ title: "SKU offer updated", color: "green" });
    } finally {
      setSaving(false);
    }
  };

  return (
    <Paper my="md" withBorder p="md">
      <Title order={4}>SKU offer</Title>
      <Text size="sm" c="dimmed" mb="md">
        Presentment for Buy SKUs. Empty means the public USD packs. Copied from
        a partner at merchant create; set here for a direct tenant.
      </Text>
      <Group align="flex-end" grow>
        <Select
          label="Currency"
          clearable
          data={[
            { value: "gbp", label: "GBP" },
            { value: "eur", label: "EUR" },
            { value: "usd", label: "USD" },
          ]}
          value={currency}
          onChange={(val) => setCurrency(val || "")}
        />
        <NumberInput
          label="Minor units per SKU"
          min={1}
          value={minor}
          onChange={setMinor}
        />
      </Group>
      <Group mt="md">
        <Button
          loading={saving}
          disabled={!currency || !(Number(minor) >= 1)}
          onClick={() =>
            save({ currency, minorPerSku: Number(minor) })
          }
        >
          Save offer
        </Button>
        <Button
          variant="outline"
          color="red"
          loading={saving}
          onClick={() => save({ currency: null, minorPerSku: null })}
        >
          Clear (public USD)
        </Button>
      </Group>
    </Paper>
  );
}
